import { Component, DestroyRef, inject, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { AppSettingsService } from '@services/app-settings.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { SHARED_MODULES } from '@shared/shared-standalone';
import { EventManagerService } from '@services/event-manager.service';
import { AppConfigService } from '@services/app-configuration.service';
import { slideFadeinUp, slideFadeinRight, zoomFadein, fadein } from '@layout/common/router-animations';
import { buildBaseUrl } from '@core/utils/url.utils';
import { defaultConfig } from '../../app.config';

import { AppFrontendConfigComponent } from '@features/control/fontend-config/frontend-config.component';
import { AccessibilityWidgetComponent } from '@layout/common/accessibility-widget/accessibility-widget.component';

const { configLoaded } = defaultConfig.appEvents;

@Component({
  standalone: true,
  selector: 'layout-auth',
  imports: [...SHARED_MODULES, AppFrontendConfigComponent, AccessibilityWidgetComponent],
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [slideFadeinUp, slideFadeinRight, zoomFadein, fadein],
})
export class LayoutAuthComponent {
  private readonly _cdr = inject(ChangeDetectorRef);
  private _settings = inject(AppSettingsService);
  private _eventManager = inject(EventManagerService);
  private _appConfig = inject(AppConfigService);

  private destroyRef = inject(DestroyRef);
  assetsBase: string;
  loginLogo: string = buildBaseUrl((defaultConfig as any).serverEntryPoint) + '/api/branding/logo/loginLogo';
  logo: string;
  isGrayTopbar: boolean;
  isCardShadow: boolean;
  isSquaredBorders: boolean;
  isBorderless: boolean;
  authPagesColor: string;
  routerAnimation: string;
  selectedInitial = 0;

  constructor() {
    this._eventManager
      .getSubject(configLoaded.name)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.assetsBase = this._appConfig.getParameter('assetsBase');
        this._cdr.markForCheck();
      });
    this._settings.changes$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(state => {
      this.logo = state.logo;
      this.isGrayTopbar = state.isGrayTopbar;
      this.isCardShadow = state.isCardShadow;
      this.isSquaredBorders = state.isSquaredBorders;
      this.isBorderless = state.isBorderless;
      this.authPagesColor = state.authPagesColor;
      this.routerAnimation = state.routerAnimation;
      this.routerAnimation = state.routerAnimation;
      this._cdr.markForCheck();
    });
  }

  onLoginLogoError(): void {
    // Si la URL del CMS falla, cae al asset empaquetado.
    this.loginLogo = '';
  }

  routeAnimation(outlet: RouterOutlet, animation: string) {
    if (animation === this.routerAnimation) {
      return outlet.isActivated && outlet.activatedRoute.routeConfig.path;
    }
  }
}
